import { render } from "./ErrorBase.vue?vue&type=template&id=9ac05c6e&scoped=true"
const script = {}

import "./ErrorBase.vue?vue&type=style&index=0&id=9ac05c6e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ac05c6e"]])

export default __exports__